import { useState } from 'react';
import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { downloadFile, getFilenameFromContentDisposition } from 'helper';
import { exportConfluenceArticlePdf } from '../api';
import { Confluence } from '../interfaces';

function useExportArticlePdf(article: Confluence.IArticle | null, onExport?: () => void) {
  const [{ error, loading }, setData] = useState<{
    loading: boolean;
    error: boolean;
  }>({ loading: false, error: false });

  const { enqueueSnackbar } = useSnackbar();

  async function handleExportArticlePdf() {
    if (!article?.id) return;

    try {
      setData((prevState) => ({ ...prevState, loading: true }));

      const response = await exportConfluenceArticlePdf(article.id);

      downloadFile(
        response.data,
        'application/pdf',
        getFilenameFromContentDisposition(response.headers['content-disposition']),
      );
    } catch (error) {
      setData({ loading: false, error: true });
      enqueueSnackbar((error as AxiosError).response?.data.message, { variant: 'error' });
    } finally {
      setData((prevState) => ({ ...prevState, loading: false }));
    }
  }

  return { loading, error, handleExportArticlePdf };
}

export default useExportArticlePdf;
